var React = require('react');

function MudraSurya (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M21,16c0,0,0-9.896,0-11s0.896-2,2-2s2,0.896,2,2\n\ts0,14,0,14 M18,35c0,0,2.398,0,3,0c4.417,0,8-4.833,8-10c0-1-0.886-2.75-1.539-4c-0.652-1.25-1.336-2-2.961-2c0,0-4.896,0-6,0\n\ts-2,0.896-2,2s0.896,2,2,2s5,0,5,0c-2.813,0-6.5,2-6.5,7 M13,18c0,0,0-9.896,0-11s-0.896-2-2-2S9,5.896,9,7s0,19,0,21\n\tc0,4.917,2.625,7,6,7c0.342,0,1,0,1,0 M21,16c0,0,0-11.896,0-13s-0.896-2-2-2s-2,0.896-2,2s0,13,0,13 M17,13c0-1.104-0.896-2-2-2\n\ts-2,0.896-2,2s0,4.896,0,6s0.896,2,2,2s2-0.896,2-2S17,14.104,17,13z"}));
}

MudraSurya.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = MudraSurya;

MudraSurya.default = MudraSurya;
